import { render } from "./Certificate.vue?vue&type=template&id=0cd4caa1"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__